import React, { useContext, useState } from 'react';
import { find } from 'lodash';
import cogoToast from 'cogo-toast';
import { useMutation } from 'graphql-hooks';
import { DispatchContext, StateContext } from '../../../../App';
import { ACTIONS } from '../../../data/reducers';
import { WebsiteLlmsUpdateMutation } from '../../../data/graphql';
import Header from '../configuration/Header';

const LlmsTxt = () => {
  const state = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const currentWebsite = find(state.websites, (w) => w.id === state.currentWebsite);
  const [llms, setLlms] = useState(currentWebsite?.llms || '');
  const [saveMutation, { loading: saving }] = useMutation(WebsiteLlmsUpdateMutation);

  const hasChanges = llms !== (currentWebsite?.llms || '');

  const handleSave = () => {
    saveMutation({
      variables: {
        websiteId: currentWebsite.id,
        llms: llms
      }
    })
      .then((res) => {
        const { ok } = res.data.websiteLlmsUpdate;
        if (ok) {
          dispatch({ type: ACTIONS.WEBSITE_LLMS_UPDATE, payload: { id: currentWebsite.id, llms } });
          cogoToast.success('llms.txt saved!');
        }
      })
      .catch(() => {
        cogoToast.error('Error saving llms.txt!');
      });
  };

  return (
    <React.Fragment>
      <Header onSave={handleSave} loading={saving} saveDisabled={!hasChanges || saving} />
      <textarea
        className='builder-w-full builder-border builder-border-gray-300 builder-p-3 builder-font-mono builder-text-sm builder-resize-none'
        style={{ minHeight: 600 }}
        value={llms}
        onChange={(e) => setLlms(e.target.value)}
        placeholder='Enter llms.txt content...'
      />
    </React.Fragment>
  );
};

export default LlmsTxt;
